
import imagem4 from '../assets/images/img-acompanhe-app/img-acompanhe-app@3x.png'
import imagem2 from '../assets/images/img-ative-tag/img-ative-tag@3x.png'
import imagem1 from '../assets/images/img-cole-veloe/img-cole-veloe@3x.png'
import imagem3 from '../assets/images/img-cole-sua-tag/img-cole-sua-tag@3x.png'

export const objCards =
[
    {
        img: imagem1,
        title: 'Peça agora e rastreie seu pedido pelo app Veloe',
        description: 'Receba sua tag em 3 dias úteis para São Paulo Capital e 5 dias úteis para as demais localidades do país.'
    },
    {
        img: imagem2,
        title: 'Ative sua tag pelo app ou site assim que ela chegar',
        description: 'A ativação acontece em instantes para uso em estacionamento e em até 6 horas para uso em pedágios.'
    },
    {
        img: imagem3,
        title: 'Cole sua tag em seu veículo',
        description: 'Sua tag deve ser colada na horizontal, do lado de dentro do vidro, perto do retrovisor.'
    },
    {
        img: imagem4,
        title: 'Acompanhe tudo pelo app',
        description: 'Pode acompanhar o uso por veículo ou compartilhe o saldo entre vários veículos no mesmo plano!'
    },
]